import { useEffect, useState, useRef } from 'react';
import { FieldType } from '../../models';

function usePreviousValue(value) {
    const ref = useRef(null);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const shouldFocusRoomField = (segments, showKidsErrors) => {
    return showKidsErrors &&
        !!segments[0].destination &&
        !!segments[0].date &&
        !(segments.length < 2 || !segments[1].date);
};

const shouldFocusArrivalField = (segments, prevSegments) => {
    const prevDestination = prevSegments?.[0].destination?.name;
    const currentDestination = segments?.[0].destination?.name;
    return !segments[0].destination && prevDestination !== currentDestination;
};

const shouldFocusDateField = (segments, leg) => {
    const currentDestination = segments?.[0].destination?.name;
    return !segments[leg]?.date && currentDestination;
};

export const useFocusField = (segments, showKidsErrors) => {
    const [fieldFocused, setFieldFocused] = useState(null);
    const prevSegments = usePreviousValue(segments);

    const focusNextField = () => {
        let fieldFocused = null;

        if (shouldFocusRoomField(segments, showKidsErrors)) {
            fieldFocused = { leg: 0, field: FieldType.ROOM };
        } else if (shouldFocusArrivalField(segments, prevSegments)) {
            fieldFocused = { leg: 0, field: FieldType.ARRIVAL };
        } else if (shouldFocusDateField(segments, 0)) {
            fieldFocused = { leg: 0, field: FieldType.DATE };
        } else if (shouldFocusDateField(segments, 1)) {
            fieldFocused = { leg: 1, field: FieldType.DATE };
        }
        setFieldFocused(fieldFocused);
    };
    useEffect(focusNextField, [segments]);

    return [fieldFocused, setFieldFocused];
};
